/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';
import EligibilitiesEligibility from './EligibilitiesEligibility';

/**
 * The EligibilitiesBody model module.
 * @module model/EligibilitiesBody
 * @version v0.3
 */
export default class EligibilitiesBody {
  /**
   * Constructs a new <code>EligibilitiesBody</code>.
   * @alias module:model/EligibilitiesBody
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>EligibilitiesBody</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/EligibilitiesBody} obj Optional instance to populate.
   * @return {module:model/EligibilitiesBody} The populated <code>EligibilitiesBody</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new EligibilitiesBody();
      if (data.hasOwnProperty('eligibility'))
        obj.eligibility = EligibilitiesEligibility.constructFromObject(data['eligibility']);
    }
    return obj;
  }
}

/**
 * @member {module:model/EligibilitiesEligibility} eligibility
 */
EligibilitiesBody.prototype.eligibility = undefined;

